import React from "react";
import Navigation from "./Navigation";

import FooterComponent from "./FooterComponent";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navigation />
      <main className="flex-1 overflow-y-auto">
        {" "}
        <div className=" container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {children}
        </div>
      </main>
      <FooterComponent />
    </div>
  );
};

export default Layout;
